import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import GoogleDFP from '@surfline/quiver-react/dist/GoogleDFP';
import entitlementsPropType from '@surfline/quiver-react/dist/PropTypes/entitlementsPropType';
import userPropType from '@surfline/quiver-react/dist/PropTypes/userPropType';
import heroAd from '../../../api/heroAd';
import heroAdConfig from './heroAdConfig';

class HeroAdUnit extends Component {
  constructor() {
    super();
    this.state = {
      tracked: false,
      error: false,
    };
  }

  componentDidMount() {
    if (this.props.placeholder === 'on') {
      this.setupAdErrorListener();
    }
  }

  componentWillUnmount() {
    if (this.open) {
      XMLHttpRequest.prototype.open = this.open;
    }
  }

  /**
   * Overrides XMLHttpRequest prototype's open method to inject listeners. We listen for opened
   * requests to https://securepubads.g.doubleclick.net that have errored. We also consider an error
   * to have taken place if no such request has been opened for 1 second.
   */
  setupAdErrorListener = () => {
    const self = this;
    self.open = XMLHttpRequest.prototype.open;
    self.adRequestCounter = 0;

    XMLHttpRequest.prototype.open = function openReplacement(...args) {
      const [method, url] = args;
      if (method === 'GET' && url.startsWith('https://securepubads.g.doubleclick.net')) {
        self.adRequestCounter += 1;
        this.onreadystatechange = () => {
          if (this.readyState === 4 && this.status !== 200) {
            self.heroAdErrored();
          }
        };
      }
      self.open.apply(this, args);
    };

    setTimeout(() => {
      if (this.adRequestCounter === 0) {
        this.heroAdErrored();
      }
    }, 1000);
  };

  heroAdErrored = () => {
    XMLHttpRequest.prototype.open = this.open;
    this.setState({
      error: true,
    });
  };

  /**
   * DFP even listener tracks hero ad render result for future placeholders.
   * @param  {Boolean} isEmpty True if hero ad did not render successfully
   */
  dfpEventListener = ({ isEmpty }) => {
    if (this.state.tracked) return;

    const { placeholder } = this.props;

    if (isEmpty) {
      heroAd('failure', placeholder);
    } else {
      setTimeout(() => {
        if (this.dfpRef.ref.offsetHeight > 0) {
          heroAd('success', placeholder, window.innerWidth, this.dfpRef.ref.offsetHeight);
        }
      }, 2000);
    }
    this.setState({ tracked: true });
  };

  heroAdClass = () => classNames({
    'sl-hero-ad-unit': true,
    'sl-hero-ad-unit--placeholder': this.props.placeholder === 'on' && !this.state.error,
  });

  render() {
    const {
      user,
      entitlements,
      qaFlag,
    } = this.props;

    return (
      <div className={this.heroAdClass()}>
        <GoogleDFP
          ref={(el) => { this.dfpRef = el; }}
          adConfig={heroAdConfig(user, entitlements, qaFlag)}
          enableSingleRequest={false}
          eventListeners={[
            { type: 'slotRenderEnded', listener: this.dfpEventListener },
          ]}
        />
      </div>
    );
  }
}

HeroAdUnit.propTypes = {
  user: userPropType,
  entitlements: entitlementsPropType.isRequired,
  qaFlag: PropTypes.string,
  placeholder: PropTypes.oneOf(['on', 'off', 'control']),
};

HeroAdUnit.defaultProps = {
  user: null,
  qaFlag: null,
  placeholder: 'control',
};

export default HeroAdUnit;



// WEBPACK FOOTER //
// ./src/bundles/margins/Header/HeroAdUnit.js